module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-md-12 wrapper-box"
  }, [_c('div', {
    staticClass: "row "
  }, [_c('div', {
    staticClass: "col-sm-5 col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "h5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterPetPrefs.AcceptCats),
      expression: "sitterPetPrefs.AcceptCats"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sitterPetPrefs.AcceptCats) ? _vm._i(_vm.sitterPetPrefs.AcceptCats, null) > -1 : (_vm.sitterPetPrefs.AcceptCats)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.sitterPetPrefs.AcceptCats,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sitterPetPrefs.AcceptCats = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sitterPetPrefs.AcceptCats = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.sitterPetPrefs, "AcceptCats", $$c)
        }
      }, function($event) {
        _vm.somethingChanged()
      }]
    }
  }), _vm._v("\n                          Accepts Cats")])]), _vm._v(" "), _c('li', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "h5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterPetPrefs.AcceptSmallDogs),
      expression: "sitterPetPrefs.AcceptSmallDogs"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sitterPetPrefs.AcceptSmallDogs) ? _vm._i(_vm.sitterPetPrefs.AcceptSmallDogs, null) > -1 : (_vm.sitterPetPrefs.AcceptSmallDogs)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.sitterPetPrefs.AcceptSmallDogs,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sitterPetPrefs.AcceptSmallDogs = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sitterPetPrefs.AcceptSmallDogs = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.sitterPetPrefs, "AcceptSmallDogs", $$c)
        }
      }, function($event) {
        _vm.somethingChanged()
      }]
    }
  }), _vm._v("\n                          Accept Small Dogs")])]), _vm._v(" "), _c('li', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "h5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterPetPrefs.AcceptMediumDogs),
      expression: "sitterPetPrefs.AcceptMediumDogs"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sitterPetPrefs.AcceptMediumDogs) ? _vm._i(_vm.sitterPetPrefs.AcceptMediumDogs, null) > -1 : (_vm.sitterPetPrefs.AcceptMediumDogs)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.sitterPetPrefs.AcceptMediumDogs,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sitterPetPrefs.AcceptMediumDogs = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sitterPetPrefs.AcceptMediumDogs = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.sitterPetPrefs, "AcceptMediumDogs", $$c)
        }
      }, function($event) {
        _vm.somethingChanged()
      }]
    }
  }), _vm._v("\n                          Accept Medium Dogs")])]), _vm._v(" "), _c('li', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "h5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterPetPrefs.AcceptLargeDogs),
      expression: "sitterPetPrefs.AcceptLargeDogs"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sitterPetPrefs.AcceptLargeDogs) ? _vm._i(_vm.sitterPetPrefs.AcceptLargeDogs, null) > -1 : (_vm.sitterPetPrefs.AcceptLargeDogs)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.sitterPetPrefs.AcceptLargeDogs,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sitterPetPrefs.AcceptLargeDogs = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sitterPetPrefs.AcceptLargeDogs = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.sitterPetPrefs, "AcceptLargeDogs", $$c)
        }
      }, function($event) {
        _vm.somethingChanged()
      }]
    }
  }), _vm._v("\n                         Accept Large Dogs")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Experience with Pets")]), _vm._v(" "), _c('li', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "h5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterPetPrefs.CanCPR),
      expression: "sitterPetPrefs.CanCPR"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sitterPetPrefs.CanCPR) ? _vm._i(_vm.sitterPetPrefs.CanCPR, null) > -1 : (_vm.sitterPetPrefs.CanCPR)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.sitterPetPrefs.CanCPR,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sitterPetPrefs.CanCPR = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sitterPetPrefs.CanCPR = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.sitterPetPrefs, "CanCPR", $$c)
        }
      }, function($event) {
        _vm.somethingChanged()
      }]
    }
  }), _vm._v("\n                          Can provide basic CPR first aid")])]), _vm._v(" "), _c('li', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "h5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterPetPrefs.CanOral),
      expression: "sitterPetPrefs.CanOral"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sitterPetPrefs.CanOral) ? _vm._i(_vm.sitterPetPrefs.CanOral, null) > -1 : (_vm.sitterPetPrefs.CanOral)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.sitterPetPrefs.CanOral,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sitterPetPrefs.CanOral = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sitterPetPrefs.CanOral = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.sitterPetPrefs, "CanOral", $$c)
        }
      }, function($event) {
        _vm.somethingChanged()
      }]
    }
  }), _vm._v("\n                          Can administer Oral medication")])]), _vm._v(" "), _c('li', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticClass: "h5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterPetPrefs.CanInject),
      expression: "sitterPetPrefs.CanInject"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sitterPetPrefs.CanInject) ? _vm._i(_vm.sitterPetPrefs.CanInject, null) > -1 : (_vm.sitterPetPrefs.CanInject)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.sitterPetPrefs.CanInject,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sitterPetPrefs.CanInject = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sitterPetPrefs.CanInject = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.sitterPetPrefs, "CanInject", $$c)
        }
      }, function($event) {
        _vm.somethingChanged()
      }]
    }
  }), _vm._v("\n                          Can provide injections if needed")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-md-7 col-xs-12"
  }, [_c('h3', [_vm._v("My Experience with Pets")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterPetPrefs.Experience),
      expression: "sitterPetPrefs.Experience"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "placeholder": "i.e I had 2 dogs for 5 years back home"
    },
    domProps: {
      "value": (_vm.sitterPetPrefs.Experience)
    },
    on: {
      "change": function($event) {
        _vm.somethingChanged()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sitterPetPrefs, "Experience", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 col-md-7 col-xs-12"
  }, [_c('h3', [_vm._v("My Restrictions and Conditions")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sitterPetPrefs.Restrictions),
      expression: "sitterPetPrefs.Restrictions"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "placeholder": "If you have any specific restrictions for Dogs or Cats that you accept, please mention them here"
    },
    domProps: {
      "value": (_vm.sitterPetPrefs.Restrictions)
    },
    on: {
      "change": function($event) {
        _vm.somethingChanged()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.sitterPetPrefs, "Restrictions", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-10 col-sm-12 col-xs-12"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn-block btn btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.updateSitterPetPrefs()
      }
    }
  }, [_vm._v(_vm._s(_vm.saveChanges))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_vm._v("Accepting Cats or Dogs is required "), _c('span', {
    staticClass: "red-star",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top",
      "data-container": "body",
      "data-content": "Required to publish your profile"
    }
  }, [_vm._v("★")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75be8318!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sitters/Profile/PetPrefs.vue
// module id = 641
// module chunks = 2